import { CustomImage } from '@/components/CustomImage';
import { useMissionListingStore } from '../../store/useMissionListingStore';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import { arrowMissionImg } from '@/components/Card/Mission';

export function MissionHero() {
  const missionListPage = useMissionListingStore((state) => state.missionListPage);
  const heroSection = missionListPage?.heroSection;
  const { src: imageSrc, alt } = useResponsiveImage(
    heroSection?.image ? { url: heroSection.image.url, alternativeText: '' } : undefined,
  );

  return (
    <div>
      <div className="relative">
        <div className="h-full max-h-[477px] w-full max-w-[849px] overflow-hidden rounded-2xl">
          <CustomImage
            src={imageSrc}
            alt={alt || heroSection?.title || 'Mission hero image'}
            className="!h-full !max-h-[477px] !w-full !max-w-[849px] object-cover"
          />
        </div>
        <img
          src={arrowMissionImg}
          alt="arrow content type"
          className="-bottom-5.5 absolute right-10 -translate-y-1/2"
        />
      </div>
      <h2 className="mt-sh-60 !font-cadiz text-sh-28-32 font-bold">{heroSection?.title}</h2>
      <p className="mt-2.5 text-sh-sm">{heroSection?.description}</p>
    </div>
  );
}
